import { request } from "@/http";

export const getCryptoPricings = () => request({
    url: '/settings/assets/view/crypto/dynamic'
})